module.exports = __webpack_public_path__ + "img/3B3C3F_DAD9D5_929290_ABACA8-256px.716d8a8e.png";